module.exports = {
    AAB_COOKIE_NAME: 'tvoid',
    AAB_COOKIE_ENABLED_VALUE: '1',
};
